<!-- eslint-disable no-mixed-spaces-and-tabs -->
<template>
	<div>
		<div class="header" :class="{'header-fixed': scroll, 'header-transparent dark': transparent,'header-light head-shadow': !transparent}">
			<div class="container">
				<nav
					id="navigation"
					:class="windowWidth > 991 ? 'navigation navigation-landscape' : 'navigation navigation-portrait'"
					:dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'"
					>
					<div class="nav-header" :style="{ float: $i18n.locale === 'ar' ? 'right' : 'left' }">
						<router-link to="" class="nav-brand text-logo" >
							<span class="svg-icon text-primary svg-icon-2hx">
								<img :src="windowWidth > 991 ? logoLight : mobileLight">
							</span>
						</router-link>
						<div class="nav-toggle" :style="{ 
							left: $i18n.locale === 'ar' ? '0' : 'auto',
							right: $i18n.locale === 'ar' ? 'auto' : '0'
						}"  @click="toggle = !toggle" ></div>
						<div class="mobile_nav" >
						</div>
					</div>
						<div 
						class="nav-menus-wrapper" 
						:class="{ 'nav-menus-wrapper-open': toggle }" 
						:style="{
						'left': toggle ? ($i18n.locale === 'ar' ? 'auto' : '0%') : ($i18n.locale === 'ar' ? '100%' : '-100%'),
						'right': $i18n.locale === 'ar' ? (toggle ? '0%' : '-100%') : 'auto'
						}"
					>
						<span class="nav-menus-wrapper-close-button" @click="toggle = !toggle">✕</span>
						<ul class="nav-menu" :style="{ float: $i18n.locale === 'ar' ? 'right' : 'left' }">
							<li>
								<router-link to="/" class="d-flex align-items-center">{{ $t('Home') }}</router-link>
							</li>
							<li>
								<router-link to="/about-us" class="d-flex align-items-center">{{ $t('About') }}</router-link>
							</li>
							<li>
								<router-link to="/contact" class="d-flex align-items-center">{{ $t('Contact Us') }}</router-link>
							</li>
							<li>
								<router-link to="/grid" class="d-flex align-items-center">{{ $t('Explore All Providers') }}</router-link>
							</li>
							<li>
								<router-link to="/privacy-page" class="d-flex align-items-center">{{ $t('Privacy Policy') }}</router-link>
							</li>
							<li>
								<router-link to="/term-condition" class="d-flex align-items-center">{{ $t('Terms and Conditions') }}</router-link>
							</li>
							<!-- <li :class="{active: ['/single-property-1','/single-property-2','/single-property-3','/single-property-4','/agencies','/agency-page','/agents','/agent-page','/add-agent','/edit-agent','/dashboard','/payment','/my-profile','/create-account','/checkout','/my-property','/bookmark-list','/change-password','/submit-property-dashboard','/submit-property','/compare-property'].includes(current),show: activeMenu['index-page'] && activeMenu['index-page']['main']}" @mouseenter="handleMouseEnter('feature-page')" @mouseleave="handleMouseLeave('feature-page')"><router-link to="" class="d-flex align-items-center">Features<span class="submenu-indicator"><span class="submenu-indicator-chevron"></span></span></router-link>
								<ul class="nav-dropdown nav-submenu" :style="{display: activeMenu['feature-page'] && activeMenu['feature-page']['main'] ? 'block' : 'none', pointerEvents: activeMenu['feature-page'] && activeMenu['feature-page']['main'] ? 'auto' : 'none'}">

									<li :class="{active: ['/single-property-1','/single-property-2','/single-property-3','/single-property-4',].includes(current),show: activeMenu['index-page'] && activeMenu['index-page']['main']}" @mouseenter="handleMouseEnter('detail-page')" @mouseleave="handleMouseLeave('detail-page')"><router-link to="" class="d-flex align-items-center justify-content-between">Single Property<span class="submenu-indicator"><span class="submenu-indicator-chevron"></span></span></router-link>
										<ul class="nav-dropdown nav-submenu" :style="{display: activeMenu['detail-page'] && activeMenu['detail-page']['main'] ? 'block' : 'none', pointerEvents: activeMenu['detail-page'] && activeMenu['detail-page']['main'] ? 'auto' : 'none'}">
											<li><router-link to="/single-property-1" :class="current === '/single-property-1' ? 'active' : ''">Single Property 1</router-link></li>                                    
											<li><router-link to="/single-property-2" :class="current === '/single-property-2' ? 'active' : ''">Single Property 2</router-link></li>                                    
											<li><router-link to="/single-property-3" :class="current === '/single-property-3' ? 'active' : ''">Single Property 3</router-link></li> 
											<li><router-link to="/single-property-4" :class="current === '/single-property-4' ? 'active' : ''">Single Property 4</router-link></li> 												
										</ul>
									</li>

									<li :class="{active: ['/agencies','/agency-page'].includes(current),show: activeMenu['index-page'] && activeMenu['index-page']['main']}" @mouseenter="handleMouseEnter('agencies-page')" @mouseleave="handleMouseLeave('agencies-page')"><router-link to="" class="d-flex align-items-center justify-content-between">Agencies<span class="submenu-indicator"><span class="submenu-indicator-chevron"></span></span></router-link>
										<ul class="nav-dropdown nav-submenu" :style="{display: activeMenu['agencies-page'] && activeMenu['agencies-page']['main'] ? 'block' : 'none', pointerEvents: activeMenu['agencies-page'] && activeMenu['agencies-page']['main'] ? 'auto' : 'none'}">                                  
											<li><router-link to="/agencies" :class="current === '/agencies' ? 'active' : ''">Agencies List</router-link></li>                                    
											<li><router-link to="/agency-page" :class="current === '/agency-page' ? 'active' : ''">Agency Page</router-link></li> 
										</ul>
									</li>

									<li :class="{active: ['/agents','/agent-page','/add-agent','/edit-agent',].includes(current),show: activeMenu['index-page'] && activeMenu['index-page']['main']}" @mouseenter="handleMouseEnter('agents-page')" @mouseleave="handleMouseLeave('agents-page')"><router-link to="" class="d-flex align-items-center justify-content-between">Agents<span class="submenu-indicator"><span class="submenu-indicator-chevron"></span></span></router-link>
										<ul class="nav-dropdown nav-submenu" :style="{display: activeMenu['agents-page'] && activeMenu['agents-page']['main'] ? 'block' : 'none', pointerEvents: activeMenu['agents-page'] && activeMenu['agents-page']['main'] ? 'auto' : 'none'}">
											<li><router-link to="/agents" :class="current === '/agents' ? 'active' : ''">Agents List</router-link></li>                                    
											<li><router-link to="/agent-page" :class="current === '/agent-page' ? 'active' : ''">Agent Page</router-link></li>
											<li><router-link to="/add-agent" :class="current === '/add-agent' ? 'active' : ''">Add Agent</router-link></li>
											<li><router-link to="/edit-agent" :class="current === '/edit-agent' ? 'active' : ''">Edit Agent</router-link></li>
										</ul>
									</li>
									<li :class="{active: ['/payment','/my-profile','/create-account','/login-page','/checkout','/my-property','/bookmark-list','/change-password','/submit-property-dashboard'].includes(current),show: activeMenu['index-page'] && activeMenu['index-page']['main']}" @mouseenter="handleMouseEnter('admin-page')" @mouseleave="handleMouseLeave('admin-page')"><router-link to="" class="d-flex align-items-center justify-content-between">My Account<span class="submenu-indicator"><span class="submenu-indicator-chevron"></span></span></router-link>
										<ul class="nav-dropdown nav-submenu" :style="{display: activeMenu['admin-page'] && activeMenu['admin-page']['main'] ? 'block' : 'none', pointerEvents: activeMenu['admin-page'] && activeMenu['admin-page']['main'] ? 'auto' : 'none'}">
											<li><router-link to="/payment" :class="current === '/payment' ? 'active' : ''">Payment Confirmation</router-link></li>
											<li v-if="isLoggedIn">
											<a href="javascript:void(0)" @click="goToProfile" :class="current.startsWith('/dashboard') || current.startsWith('/user_dashboard') ? 'active' : ''">
												{{ $t('Profile') }}
											</a>
											</li>                                     
											<li><router-link to="/create-account" :class="current === '/create-account' ? 'active' : ''">{{$t('Create An Account')}}</router-link></li>                                    
											<li><router-link to="/login-page" :class="current === '/login-page' ? 'active' : ''">{{$t('Login')}}</router-link></li>                                    
											<li><router-link to="/checkout" :class="current === '/checkout' ? 'active' : ''">Checkout</router-link></li>                                    
											<li><router-link to="/my-property" :class="current === '/my-property' ? 'active' : ''">Property List</router-link></li>                                    
											<li><router-link to="/bookmark-list" :class="current === '/bookmark-list' ? 'active' : ''">Bookmarked Listings</router-link></li>                                    
											<li v-if="isLoggedIn"><router-link to="/change-password" :class="current === '/change-password' ? 'active' : ''">{{$t('Change Password')}}</router-link></li>
											<li><router-link to="/submit-property-dashboard" :class="current === '/submit-property-dashboard' ? 'active' : ''">Submit Property Dashboard</router-link></li> 
										</ul>
									</li>
									<li>
										<router-link to="/compare-property" :class="current === '/compare-property' ? 'active' : ''">Compare Property</router-link>                                
									</li>
									<li>
										<router-link to="/submit-property" :class="current === '/submit-property' ? 'active' : ''">Submit Property</router-link>                                
									</li>
								</ul>
							</li> -->
							<!-- Language Switcher inside the nav menu -->
							<li class="locale-changer">
								<div class="custom-dropdown" @click="toggleDropdown = !toggleDropdown" ref="dropdownRef">
								<div class="selected">
									<img :src="selectedFlag" alt="flag" />
									<span class="lang-name">{{ getLangName(locale) }}</span>
								</div>
								<ul v-if="toggleDropdown" class="dropdown-list">
									<li v-for="(locale, index) in availableLocales" :key="index" @click="changeLocale(locale)" class="dropdown-item">
									<div class="flag-container">
										<img :src="getFlag(locale)" alt="flag" class="flag-circle" />
										<span class="lang-name">{{ getLangName(locale) }}</span>
									</div>
									</li>
								</ul>
								</div>
							</li>
						</ul>
					</div>
						
					<!-- <ul class="nav-menu nav-menu-social align-to-right">
						<li>
							<div class="btn-group account-drop">
								<button type="button" class="btn btn-order-by-filt dropdown-toggle" id="showbutton" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
									<img :src="users1" class="avater-img" alt="">Hi, Admin
								</button>
								<div class="dropdown-menu pull-right animated flipInX" id="showing">
									<router-link to="/dashboard"><i class="fa-solid fa-gauge px-2"></i>Dashboard</router-link>
									<router-link to="/my-profile"><i class="fa-solid fa-address-card px-2"></i>My Profile</router-link>                                  
									<router-link to="/my-property"><i class="fa-solid fa-building-circle-check px-2"></i>My Property</router-link>                                   
									<router-link to="/bookmark-list"><i class="fa-solid fa-bookmark px-2"></i>Bookmarked Property</router-link>                                   
									<router-link to="/submit-property-dashboard"><i class="fa-solid fa-house px-2"></i>Submit Property</router-link>                                   
									<router-link to="/change-password"><i class="fa-solid fa-unlock px-2"></i>Change Password</router-link>
								</div>
							</div>
						</li>
					</ul> -->
				</nav>
			</div>
		<div class="clearfix"></div>
	</div>
	</div>
</template>

<script setup>
    // import { onMounted, ref, defineProps,onBeforeUnmount, computed } from 'vue';
    import { onMounted, ref, defineProps,onBeforeUnmount } from 'vue';

	// import users1 from '@/assets/img/team-1.jpg'
	// import logo from '@/assets/img/logo.svg'
	import logoLight from '@/assets/img/svg/Logo-g.webp'
	import mobileLight from '@/assets/img/svg/logo-dash.png'	
	// import { useRoute, useRouter } from 'vue-router';
	import enflag from '@/assets/img/svg/en.png';
	import arflag from '@/assets/img/svg/sy.svg';
	import trflag from '@/assets/img/svg/tr.png';
	import { useI18n } from 'vue-i18n';
	const toggleDropdown = ref(false);
	const availableLocales = ['en', 'ar','tr'];
	const selectedFlag = ref('');
	const dropdownRef = ref(null);

	onMounted(() => {
	window.scrollTo(0, 0);
	window.addEventListener('resize', handleResize);
	window.addEventListener('scroll', handleScroll);

	const { locale } = useI18n();
	selectedFlag.value = getFlag(locale.value);
	document.addEventListener('click', closeDropdownOnClickOutside);
	});
	const { locale } = useI18n();
	const changeLocale = (localeValue) => {
	locale.value = localeValue;
	localStorage.setItem('locale', locale.value);
	selectedFlag.value = getFlag(localeValue);
	toggleDropdown.value = false; 
	//   window.location.reload(); 
	};

	const closeDropdownOnClickOutside = (event) => {
	if (dropdownRef.value && !dropdownRef.value.contains(event.target)) {
		toggleDropdown.value = false;
	}
	};

	const getFlag = (locale) => {
		if (locale === 'ar') return arflag;
		if (locale === 'tr') return trflag;
		return enflag;
	};
	defineProps({
		transparent:Boolean
	})

	onMounted(() => {
	window.scrollTo(0, 0);
	window.addEventListener('resize', handleResize);
	window.addEventListener('scroll', handleScroll);

	const { locale } = useI18n();
	selectedFlag.value = getFlag(locale.value);
	document.addEventListener('click', closeDropdownOnClickOutside);
	});
	onBeforeUnmount(() => {
	document.removeEventListener('click', closeDropdownOnClickOutside);
	});
    // const activeMenu = ref({});
	const toggle = ref(false)
	// const router = useRoute();
    // const current = ref(router.path);
	const windowWidth= ref(window.innerWidth);

	const scroll = ref(false)

	const handleResize = () => {
      windowWidth.value = window.innerWidth;
    };

	const handleScroll = () => {
        if (window.scrollY >= 50) {
            scroll.value = true
        } else {
            scroll.value = false
        }
    }


	onMounted(()=>{
		window.scrollTo(0,0)
		window.addEventListener('resize', handleResize);
		window.addEventListener('scroll', handleScroll);
	})
	const getLangName = (locale) => {
		if (locale === 'ar') return 'Ar';
		if (locale === 'tr') return 'Tr';
		return 'En';
	};
    // const handleMouseEnter = (menu, submenu = 'main') => {
    //     if (!activeMenu.value[menu]) {
    //         activeMenu.value[menu] = {};
    //     }
    //     activeMenu.value[menu][submenu] = true;
    // };

    // const handleMouseLeave = (menu, submenu = 'main') => {
    //     if (activeMenu.value[menu]) {
    //         activeMenu.value[menu][submenu] = false;
    //     }
    // };
	// const isLoggedIn = computed(() => {
	// return !!localStorage.getItem('auth_token');
	// });
	// const token = localStorage.getItem('auth_token');
	// const userRole = localStorage.getItem('user_type');
	// const userId = localStorage.getItem('user_id');
	// const route = useRouter();
	// const goToProfile = () => {
	// if (!token) {
	// 	route.push('/login-page');
	// } else if (userRole === 'Service Provider') {
	// 	route.push(`/dashboard/${userId}`);
	// } else {
	// 	route.push(`/user_dashboard/${userId}`);
	// }
	// };
</script>
<style scoped>
.locale-changer {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 15px;
  margin-top: 1%;
}

.custom-dropdown {
  position: relative;
  cursor: pointer;
}

.selected {
  display: flex;
  align-items: center;
  padding: 5px 10px;
}

.selected img {
  width: 68px;
  height: 35px;
  margin-right: 10px;
}

.dropdown-list {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  list-style: none;
  padding: 0;
  margin: 0;
  z-index: 10;
  max-height: 200px;
  overflow-y: auto;
}

.dropdown-item {
  display: flex;
  align-items: center;
  padding: 10px;
  /* transition: background-color 0.3s ease; */
  background-color: white;
}

.dropdown-item:hover {
  cursor: pointer;
  background-color: #f1f1f1;
}

/* Style for flag container */
.flag-container {
  display: flex;
  align-items: center;
}

.flag-circle {
  width: 30px;
  height: 30px;
  /* border-radius: 50%; */
  margin-right: 10px;
}
.flag-container .lang-name{
  font-size: 14px;
  color:#2c3f56;
}
.lang-name {
  font-size: 14px;
  color: white;
}

.selected {
  display: flex;
  align-items: center;
  padding: 5px 10px;
}

.selected img {
  width: 30px;
  height: 30px;
  /* border-radius: 50%; */
  margin-right: 10px;
}

</style>